import {
  appSignedInRoutePath,
  passwordChangeRoutePath,
  passwordResetRoutePath,
  registerRoutePath,
  resetPasswordConfirmationRoutePath,
  signInRoutePath,
} from 'config/routePaths'

const authPaths = new Set([
  appSignedInRoutePath,
  passwordChangeRoutePath,
  passwordResetRoutePath,
  registerRoutePath,
  resetPasswordConfirmationRoutePath,
  signInRoutePath,
  '/users/sign_out',
])

const hasUnsafeCharacters = value => Array.from(value).some(character =>
  character === '\\' || character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127)

export const safeReturnTo = value => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null

  try {
    // Check the decoded path too: browsers normalize backslashes, dot segments,
    // and control characters, and routers may decode escaped path separators.
    const url = new URL(value, window.location.origin)
    const decodedPath = decodeURIComponent(url.pathname)
    if (hasUnsafeCharacters(value) || hasUnsafeCharacters(decodedPath) || decodedPath.includes('%')) return null

    const normalized = new URL(decodedPath, window.location.origin)
    if (url.origin !== window.location.origin || normalized.origin !== window.location.origin) return null
    if (normalized.pathname.startsWith('//')) return null
    if (authPaths.has(normalized.pathname.replace(/\/+$/, '')) || normalized.pathname.startsWith('/team_users/auth/')) return null

    return `${normalized.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

export const getReturnTo = search => {
  const params = new URLSearchParams(search)
  return params.get('expandrive_app') === 'true' ? null : safeReturnTo(params.get('return_to'))
}

export const withReturnTo = (path, returnTo) => {
  const destination = safeReturnTo(returnTo)
  return destination ? `${path}?${new URLSearchParams({ return_to: destination })}` : path
}
